import { LEARN_CATEGORIES_FULL } from 'services/contentful/gql/query'
import { queryApollo } from 'services/contentful/helpers'
import { logApolloError } from 'services/logging/logServerError'
import { getSlug } from 'utils/conversions'
import { getPageContentTypes } from 'lib/getPageContentType'

export const DEFAULT_LIST = [
  'news',
  'achieve-insights',
  'everyday-finances',
  'real-stories',
  'debt-solutions',
  'debt-basics',
  'debt-consolidation',
  'home-equity-loans',
  'money-tips-education',
  'personal-loans',
  'debt-relief',
  'achieve-mobile-apps',
  'debt-shaming',
  'member-stories',
  'money-relationships',
  'planning-for-the-future',
  'reducing-debt',
  'wtfinance',
]

export const DEFAULT_FILTER_LIST = {
  news: 'News',
  'achieve-insights': 'Achieve Insights',
  'everyday-finances': 'Everyday Finances',
  'real-stories': 'Real Stories',
  'debt-solutions': 'Debt Solutions',
  'debt-basics': 'Debt Basics',
  'debt-consolidation': 'Debt Consolidation',
  'home-equity-loans': 'Home Equity Loans',
  'money-tips-education': 'Money Tips & Education',
  'personal-loans': 'Personal Loans',
  'debt-relief': 'Debt Relief',
  'achieve-mobile-apps': 'Achieve Mobile Apps',
  'debt-shaming': 'Debt Shaming',
  'member-stories': 'Member Stories',
  'money-relationships': 'Money & Relationships',
  'planning-for-the-future': 'Planning for the Future',
  'reducing-debt': 'Reducing Debt',
  wtfinance: 'WTFinance',
}

// We have to query all the longFormContentCollection to get the primary and secondary categories.
// This is because graphql cannot query the category drop down list field itself
// TODO: We can switch to contentful management APi in the future to get only field data for a specific entry in the future
export const filterLongformContentSecondaryCategory = async () => {
  try {
    const { websiteField } = getPageContentTypes()
    const allCategories = await queryApollo(LEARN_CATEGORIES_FULL, {
      where: { website: websiteField },
    })
    const allCategoriesMap = {}

    allCategories?.data?.longFormContentCollection?.items?.map((e) => {
      e.secondaryCategory?.map((secondary) => {
        allCategoriesMap[getSlug(secondary)] = secondary
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      e.primaryCategory && (allCategoriesMap[getSlug(e.primaryCategory)] = e.primaryCategory)
    })
    return allCategoriesMap
  } catch (error) {
    logApolloError(error)
    return DEFAULT_FILTER_LIST
  }
}
